import './pdf_reportordermail.css';
import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import reportService from "../../features/report/reportService";
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';
import moment from "moment";
import _ from 'lodash';

function PDFReportOrderMail() {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    console.log('queryParams', queryParams);
    // Retrieve specific query parameters  
    const districtId = queryParams.get('districtId');
    const authorization = queryParams.get('token');
    const academicyear = queryParams.get('academicyear');
    console.log('districtId', districtId);
    console.log('auth', authorization);

    let [reportOrderData, setReportOrderData] = useState([]);
    const [distName, setDistName] = useState('');
    let [isPageLoad, setisPageLoad] = useState(false);
    let [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        reportService.getReportPageDatePDF({ districtId: districtId, academicyear: academicyear}, authorization).then((response) => {
            setDistName(response.data.distName)
            setReportOrderData(response.data);
            setIsLoading(false)
            setisPageLoad(true)
            console.log(response.data)
        }).catch(err => {
            toast.error(err.message ? err.message : "Unable to fetch enrollment data.");
        })
    }, []);

    //New Code Added **START
      let CombinedSchoolrptdata = [];
      let CombinedSchoolrptdataFinal = [];
      let flattenedData = _.map(reportOrderData.schoolReportData, (value, key, object) => {
          _.map(value["schoolRepDataArr"], (value1, key1, object1) => {
              value1["ParentName"] = value["name"];
              CombinedSchoolrptdata.push(value1);
          });
      });
      _.map(CombinedSchoolrptdata, (value, key, object) => {
          value["P1"] = 0;
          value["P2"] = 0;
          value["P3"] = 0;
          value["P4"] = 0;
          let temp = _.filter(CombinedSchoolrptdata, {
              name: value.name
          });
          let mainData = _.filter(temp, (value, key, object) => {
              return (_.find(value["reportSchoolData"], { "value": 1 }));
          });
          if (mainData.length > 0) {
              let temp1 = {};
              _.map(mainData, (v, k) => {
                  if (k == 0) {
                      temp1 = _.cloneDeep(v);
                  }
                  switch (v["ParentName"]) {
                      case 'Elementary School':
                          temp1["P1"] = 1;
                          break;
                      case 'Secondary School':
                          temp1["P2"] = 1;
                          break;
                      case 'Staff School':
                          temp1["P3"] = 1;
                          break;
                      case 'Parent School':
                          temp1["P4"] = 1;
                          break;
                      default:
                          break;
                  }
                  CombinedSchoolrptdataFinal.push(temp1);
              });
          } else {
              CombinedSchoolrptdataFinal = _.concat(CombinedSchoolrptdataFinal, temp);
          }
      });
      CombinedSchoolrptdataFinal = _.sortBy(_.uniqBy(CombinedSchoolrptdataFinal, "schoolId"),['name']);
      console.log(CombinedSchoolrptdataFinal);
    //New Code Added **END

    const convertDate = (dateStr) => {
        return moment(dateStr).format('MM/YY');
    }

   const renderMailTableStructure = () => {
    const firstPageItems = 18;
    const otherPageItems = 32;

    // total items after subtracting first page
    const remainingItems = CombinedSchoolrptdataFinal.length - firstPageItems;

    // number of pages after first one
    const extraPages = remainingItems > 0 ? Math.ceil(remainingItems / otherPageItems) : 0;

    // total number of pages (first page + rest)
    const numPages = 1 + extraPages;

    const getPageSlice = (pageIndex) => {
        if (pageIndex === 0) {
            return CombinedSchoolrptdataFinal.slice(0, firstPageItems);
        } else {
            const start = firstPageItems + (pageIndex - 1) * otherPageItems;
            const end = start + otherPageItems;
            return CombinedSchoolrptdataFinal.slice(start, end);
        }
    };

    return (
        <div>
            {Array.from({ length: numPages }).map((_, pageIndex) => (
                <Table key={pageIndex} sx={{ minWidth: 680 }} aria-label="simple table">
                    <TableHead className="pdfmail_setHeaderbackground">
                        <TableRow>
                            <TableCell align="left" className="reportheaderText"
                                style={{ width: "32%" }}>School Name</TableCell>
                            <TableCell align="left" className="reportheaderText"
                                style={{ width: "14%" }}>CDS Code</TableCell>
                            <TableCell align="left" className="reportheaderText reportheaderText_align"
                                style={{ width: "12.5%" }}>Elementary CHKS Report</TableCell>
                            <TableCell align="left" className="reportheaderText reportheaderText_align"
                                style={{ width: "12.5%" }}>Secondary CHKS Report</TableCell>
                            <TableCell align="left" className="reportheaderText reportheaderText_align"
                                style={{ width: "12.5%" }}>CSSS Report</TableCell>
                            <TableCell align="left" className="reportheaderText reportheaderText_align"
                                style={{ width: "12.5%" }}>CSPS Report</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody className="pdfreportmail_setBodybackground">
                        {getPageSlice(pageIndex).map((report, index) => (
                            <TableRow key={index}>
                                <TableCell sx={{ fontSize: '16px' }}>{report.name}</TableCell>
                                <TableCell sx={{ fontSize: '16px' }}>{report.ncesId}</TableCell>
                                <TableCell className="imageCell">
                                    {report.P1 == 1 && (
                                        <img className="imageCheckreportPdf" src={require('../../assets/images/surveyCheck_new.png')} alt="Distric Check" />
                                    )}
                                </TableCell>
                                <TableCell className="imageCell">
                                    {report.P2 == 1 && (
                                        <img className="imageCheckreportPdf" src={require('../../assets/images/surveyCheck_new.png')} alt="Distric Check" />
                                    )}
                                </TableCell>
                                <TableCell className="imageCell">
                                    {report.P3 == 1 && (
                                        <img className="imageCheckreportPdf" src={require('../../assets/images/surveyCheck_new.png')} alt="Distric Check" />
                                    )}
                                </TableCell>
                                <TableCell className="imageCell">
                                    {report.P4 == 1 && (
                                        <img className="imageCheckreportPdf" src={require('../../assets/images/surveyCheck_new.png')} alt="Distric Check" />
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            ))}
        </div>
    );
};



    const TableRowStyledReportPdf = styled(TableRow)`
        &:nth-of-type(odd) {
        background-color: #f6f6f6;
        }
        &:nth-of-type(even) {
            background-color: #fff;
        }
    `;

    return (
        <>
            <div className='pdfreportmail_pageHeader'>
                <div id="pdfImage"><img alt="Delete School" src={require("../../assets/images/menuHeader_new.png")} className="pdfreportmail_logoSize"></img></div>
                <div className="pdfmail_ImageSub">CalSCHLS Coordinator Portal </div>
                <div className="pdfmail_pgTitle">ORDER CONFIRMATION FOR OPTIONAL REPORTS</div>
                <div className="pdfmail_country">{distName}</div>
                <div className="pdfmail_pgDistrict">DISTRICT DATA</div>
            </div>
            <div className='pdfreportmail_pageContent'>
                <div className='pdfreportmail_userTable'>
                    <TableContainer component={Paper} className="pdfOrder_tableStyle">
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead className="pdfmail_setHeaderbackground">
                                <TableRow>
                                    <TableCell align="left" ref={el => {
                                            if (el) {
                                            el.style.setProperty('width', '20%', 'important');
                                            }
                                        }} className='reportheaderText'>All CalSCHLS Surveys</TableCell>
                                    <TableCell align="left" className='reportheaderText reportheaderText_align'>Data Dashboard </TableCell>
                                    <TableCell align="left" className='reportheaderText reportheaderText_align'>District Raw Dataset</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody className="pdfreportmail_setBodybackground">
                                {reportOrderData.distReportData && reportOrderData.distReportData.map((data, key) => (
                                <TableRow>
                                    <TableCell>{data.surveyName} </TableCell>
                                    <TableCell className='mail_imageCell'>
                                    {reportOrderData.subscriptionStartDate ?
                                        <img className='imageCheckreportPdf' src={require('../../assets/images/surveyCheck_new.png')} alt='Distric Check'></img>
                                    : ''}
                                    </TableCell>
                                    <TableCell className='mail_imageCell'>
                                    {data.distReportData[0].value  == 1?
                                        <img className='imageCheckreportPdf' src={require('../../assets/images/surveyCheck_new.png')} alt='Distric Check'></img>
                                    : ''}
                                    </TableCell>
                                </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        {reportOrderData.subscriptionEndDate ? <div className='reportNote'>Note: Data Dashboard expires {convertDate(reportOrderData.subscriptionEndDate)}</div> : ''}
                        <div className='mail_schoolReportText'>SCHOOL REPORTS - Only checked items are included in your order</div>

                        { renderMailTableStructure() }
                    </TableContainer>

                </div>
            </div>
            {isPageLoad ? <div id="pageload" ></div> : ''}
        </>
    )
}

export default PDFReportOrderMail